import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { LoadingState } from '../components/States'
import { can } from './AuthContext'
import type { Capability } from './AuthContext'
import { useAuth } from './useAuth'

interface Props {
  children: ReactNode
  /** When set, the route also requires this capability. */
  capability?: Capability
}

export function RequireAuth({ children, capability }: Props) {
  const { user, bootstrapping } = useAuth()
  const location = useLocation()

  if (bootstrapping) return <LoadingState label="Restoring your session…" />

  if (!user) {
    // Remember where they were going so login can send them back.
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }

  if (capability && !can(user.role, capability)) {
    return <Navigate to="/app/forbidden" replace />
  }

  return <>{children}</>
}
